/* template */
<template><es-layout custom-class :layout="(['header','footer'])" navbarTitle="短信核验" :leftArrow="(true)" :navbarStyle="(navbarStyle)"><div class="backgroundStyle"><div class="es-background-card"><template v-if="(!isFromDigitCode)"><div class="titleStyle">第一步：获取验证码</div><div class="contentStyle">请用手机<span class="es-font-sent">{{ phoneTips }}</span>发送短信<span class="es-content-hover">{{msg}}</span>至<span class="es-content-hover">12306</span>，获取短信验证码</div><template><mpx-view @tap="sendMessage" class="buttonStyle">去发送校验短信</mpx-view></template></template><div class="titleStyles">{{title}}</div><div class="contentStyle">请在<span class="es-font-sent">10</span>分钟内，输入<span class="es-font-sent">12306</span>返回的验证码，点击提交核验</div><div class="inputContainerStyle"><div class="messageStyle">验证码</div><div class="messageBorder">|</div><mpx-input type="text" placeholder="请输入6位数验证码" :value="inputdata" mpxModelEvent="input" @mpxModel='__model("inputdata", $event, ["value"], undefined)' :maxlength="(6)" class="inputStyle"/></div><mpx-view :class="(actives)" @tap="onClick" class="buttonStyle">{{btnText}}</mpx-view></div></div><div class="tips" v-if="(isALIMini)"><mpx-image :src="(tipsIcon)" class="tips-icon"/><div class="tips-title">温馨提示</div><template v-for="(item, index) in (tipsText)"><div class="tips-text">{{item}}</div></template></div><successDialog :show="(showDialog)" title="注册成功" :account="(nickname)" :password="(password)" @confirm="gotologin"/><failDialog :show="(showFailDialog)" title="核验失败" :msg="(failmsg)" @confirm="gocurrent"/></es-layout></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m5dfd6d94"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-view-page
    background-color $train-color-background
  .es-navbar
    background #ffffff
  .es-content-hover
    color $train-color-theme-blue
    font-size 16px
    font-family sans-serif
  .es-background-card
    background #ffffff
    border-radius 8px
    padding 16px 12px
    padding-top 0
  .tab-label
    padding 0 5px
    position absolute
    font-size 10px
    height 18px
    line-height 18px
    color #ffffff
    background #FD6C19
    border-radius 9px
    border 1px solid #ffffff
  .backgroundStyle
    padding 12px
    background-color $train-color-background
  .title
    margin-left 10px
    padding 10 20
    color black
    font-size 20px
    text-align center
    background #FD6C19
    border 1px solid #ffffff
    width 250px
    height 25px
  .titleStyle
    padding-top 16px
    padding-bottom 12px
    color #000000
    font-size 18px
    font-weight bold
  .titleStyles
    padding-top 24px
    padding-bottom 12px
    color #000000
    font-size 18px
    font-weight bold
  .contentStyle
    color $train-color-666
    font-size 16px
    font-family PingFangSC
  .messageStyle
    color $train-color-333
    font-size 15px
    display inline-block
    // width 60px
    text-align center
    flex 0 0 50px
  .inputStyle
    font-size 15px
    color $train-color-666
    outline none
    height 22px
    caret-color $train-color-theme-blue
  .messageBorder
    color #C0C0C0
    padding 0 10px
  .buttonStyle
    margin-top 16px
    color white
    background $train-color-theme-blue
    font-size 16px
    border-color $train-color-theme-blue
    padding 13px 10px
    text-align center
    border-radius 8px
  .search
    color $train-color-divider-cc
    font-size 15px
    height 44px
    padding 13px
    width 100%
    outline none
    box-sizing border-box
  .inputContainerStyle
    margin-top 10px
    padding 10px
    display flex
    align-items center
    border-radius 8px
    border 2px #F3F3F3 solid
    width 100%
    box-sizing border-box
  .inputStyle::placeholder
    color $train-color-divider-ccc
  .button-not-active
    background $train-color-divider-ccc
  .es-navbar-view
    background-color #ffffff
  .es-font-sent
    font-family sans-serif
    color $train-color-theme-blue
  .tips-icon
    width 14px
    height 14px
    position absolute
    left 13px
  .tips-title
    font-family PingFangSC-Regular
    font-size 12px
    font-weight normal
    letter-spacing 0em
    line-height 14px
    letter-spacing 0px
    color #333333
    margin-bottom 7px
    margin-left 29px
    margin-right 14px
  .tips-text
    font-family PingFangSC-Regular
    font-size 12px
    font-weight normal
    letter-spacing 0em
    line-height 14px
    letter-spacing 0px
    color #3D3D3D
    margin-left 29px
    margin-right 14px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5dfd6d94"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./verification-code.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./verification-code.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m5dfd6d94"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"component":true},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-button':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-dialog':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/dialog/index.mpx?isComponent&outputPath=components%2Findex3651661c%2Findex")),'successDialog':getComponent(require("./components/register/success-dialog.mpx?isComponent&outputPath=components%2Fsuccess-dialog06d7bf44%2Findex")),'failDialog':getComponent(require("./components/register/fail-dialog.mpx?isComponent&outputPath=components%2Ffail-dialogafb93a0e%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
